import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

export default function CookiePolicy() {
    const { lang } = useLanguage();

    useEffect(() => {
        if (window.CookieFirst && typeof window.CookieFirst.renderEmbeds === 'function') {
            window.CookieFirst.renderEmbeds();
        }
    }, [lang]);

    return (
        <div className="min-h-screen py-24 px-6 max-w-4xl mx-auto dark:text-slate-300">
            <div className="space-y-8">
                <h1 className="text-3xl md:text-4xl font-bold mb-8 text-[#0A1628] dark:text-white">
                    {lang === "es" ? "Política de Cookies" : "Cookie Policy"}
                </h1>
                
                {/* 
                    Contenedor principal de la política. 
                    CookieFirst inyecta aquí tanto el texto como la tabla de cookies.
                */}
                <div id="cookiefirst-policy-page" className="cookiefirst-custom-styles"></div>
                
                <div className="text-sm text-slate-500 mt-8 pt-8 border-t border-slate-200 dark:border-slate-800">
                    {lang === "es" ? (
                        <>
                            Esta política de cookies ha sido creada y actualizada por <a href="https://cookiefirst.com/es/" className="underline hover:text-[#0A1628] dark:hover:text-white transition-colors" target="_blank" rel="noopener noreferrer">CookieFirst</a>.
                        </>
                    ) : (
                        <>
                            This cookie policy has been created and updated by <a href="https://cookiefirst.com/" className="underline hover:text-[#0A1628] dark:hover:text-white transition-colors" target="_blank" rel="noopener noreferrer">CookieFirst</a>.
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
